module.exports = __webpack_public_path__ + "static/media/Gyarados_gaussian2.ce00d72c.png";